type DefaultRoutes = {
  /** The relative URL path used for the route */
  path: string;
  /** THe name to display to the user (usually in the form of a 'Tab' name) */
  name: string;
  /**
   * A role name to restrict route access to, a value of null/undefined means
   * the route should be accessible without a permission check.
   */
  restrictToRole?: string;
};

export const DEFAULT_ROUTES: DefaultRoutes[] = [
  {
    name: 'Document Types',
    path: '/admin/configurations/document-types-list',
  },
  {
    name: 'Submission Types',
    path: '/admin/configurations/submission-types-list',
  },
  {
    name: 'System Controls',
    path: '/admin/configurations/system-controls',
    restrictToRole: 'IT Admin',
  },
];
